import clsx from 'clsx'
import { memo, useMemo } from 'react'

import type { PropsWithClassName } from '@fv/client-types'

import { useCurrency } from '@/hooks/settings'

type Props = {
  amount?: number
  currency: string
  className?: string
  size?: 'sm' | 'lg'
}
export const Price = memo(function Price({
  amount,
  currency,
  className,
  size,
}: Props) {
  const sizeClass =
    size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-2xl' : 'text-[1.3rem]'

  const composePriceParts = useCurrency()
  const [dollars, cents] = amount !== undefined ? composePriceParts(amount) : []

  if (dollars === undefined || cents === undefined) return null

  return (
    <div
      className={clsx(
        'text-zinc-900 font-oxygen inline-flex items-start',
        sizeClass,
        className,
      )}
    >
      <span className="leading-none">${dollars}</span>
      <span className="text-[.65em] ml-[.15em] leading-none">
        <span className="underline">{cents}</span>
        {currency && <span className="ml-1">{currency?.toUpperCase()}</span>}
      </span>
    </div>
  )
})

export const PricePlain = memo(function PricePlain({
  amount,
  className,
}: PropsWithClassName<{ amount?: number }>) {
  const composePriceParts = useCurrency()
  const [dollars, cents] = useMemo(
    () => (amount !== undefined ? composePriceParts(amount) : []),
    [amount, composePriceParts],
  )

  if (dollars === undefined || cents === undefined) return null

  return (
    <span className={className}>
      ${dollars}.{cents}
    </span>
  )
})
